import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathNotes: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMathNotes"><Path d="M12 3.5V20.5M3.5 12H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 19.5C12 19.5 12 4.5 20.5 4.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5 5L7 6.92857M7 6.92857L9 5M7 6.92857V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15 15L19 19M19 15L15 19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMathNotes;
